var map = {
	"./de": 14,
	"./de.js": 14,
	"./en-gb": 15,
	"./en-gb.js": 15,
	"./es": 16,
	"./es.js": 16,
	"./fr": 17,
	"./fr.js": 17,
	"./it": 18,
	"./it.js": 18,
	"./ja": 19,
	"./ja.js": 19,
	"./ko": 20,
	"./ko.js": 20,
	"./pt": 21,
	"./pt.js": 21,
	"./ru": 22,
	"./ru.js": 22,
	"./tr": 23,
	"./tr.js": 23,
	"./zh-cn": 24,
	"./zh-cn.js": 24
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;



//////////////////
// WEBPACK FOOTER
// ../~/moment/locale (fr|de|es|en-gb|zh-cn|it|ja|pt|ko|tr|ru)(\.js)?$
// module id = 42
// module chunks = 0 1